import React, {useState, useEffect} from "react";
import { BaseUrl } from "../../../../../../Actions/Base";
import CryptoJS from "crypto-js";
import axios from "axios";

const SECRET_KEY = "my-secret";

const UserInput = ({
  AuthPageName,
  Credentials,
  setCredentials,
  Errors,
  setErrors,
  PasswordError,
  handleOTPChange,
  otp,
  setOtpSent,
  setOtpVerified, // New: to notify parent about OTP verification

}) => {

  const [view, setView] = useState(true)
  const [cview, setCivew] = useState(true)
  let InputBoxStyle = `w-full rounded-[6px] outline-none bg-[#F3F6F7] text-gray-400
    text-4xs md:text-[16px]   lg:text-[16px]     xl:[16px]      2xl:text-[21px]
    py-[6px] lg:py-[3px]    xl:py-3
    px-[8px]                    xl:px-[22px]    2xl:px-7`;

  const borderr = {
    border: "1px solid #BCBCBC",
  };

  const Border = "border-[#E2E2E2] border-[1px] border-solid";

  let labelStyle = `text-4xs md:text-[16px] text-white md:text-black   lg:text-[16px]     xl:[16px]      2xl:text-[21px]  pb-2`;

  const OnPasswordChange = (e) => {
    delete Errors?.Invalid;
    let Check = true;
    if (AuthPageName === "Sign Up") {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$/;
      Check = regex.test(e.target.value);
    }

    setCredentials({ ...Credentials, Password: e.target.value });

    if (e.target.value === "") setErrors({ ...Errors, Password: true });
    else if (!Check)
      setErrors({
        ...Errors,
        Password:
          "Password must contain a capital letter, a small letter,a number and a special character with minimum length 8",
      });
    else {
      delete Errors?.Password;
      setErrors(Errors);
    }
  };


  const OnChange = (e, name) => {
    setCredentials({ ...Credentials, [name]: e.target.value });
    if (name === "Password" || name === "Email") delete Errors?.Invalid;

    if (e.target.value === "") setErrors({ ...Errors, [name]: true });
    else {
      delete Errors?.[name];
      setErrors({ ...Errors });
    }
  };
const mar = `${AuthPageName === 'Sign Up' ? 'mt-[3rem]' : ''}`

const [resendTimer, setResendTimer] = useState(0);

const axiosInstance = axios.create({
  baseURL: BaseUrl,
  withCredentials: true,
});

 // Whenever resendTimer > 0, count it down every second
 useEffect(() => {
  let intervalId;
  if (resendTimer > 0) {
    intervalId = setInterval(() => {
      setResendTimer((prev) => prev - 1);
    }, 1000);
  }
  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [resendTimer]);

const [otpError, setOtpError] = useState("");

// const generateAndSendOtp = async (e) => {
//     e.preventDefault(); // ✅ Prevent form submission

//    // If still cooling down, do nothing
//    if (resendTimer > 0) return;

//   const email = Credentials?.Email;
//   if (!Credentials?.Email) {
//     setErrors({ ...Errors, Email: "Please enter your email first" });
//     setOtpError("Please enter your email first")
//     return;
//   }

//   // ✅ Step 1: Generate OTP (fixed for specific domains)
//   const hostname = window.location.hostname;
//   const isLocalOrProd =
//     hostname === "localhost" || hostname === "prod.vehiclelearning.com";

//   const randomOtp = isLocalOrProd
//     ? "1122" // ✅ Fixed OTP for local and production URLs
//     : Math.floor(1000 + Math.random() * 9000).toString();

//   // Step 1: Generate random 4-digit OTP
//   // const randomOtp = Math.floor(1000 + Math.random() * 9000).toString();

//   // Step 2: Encrypt the OTP
//   const encryptedOtp = CryptoJS.AES.encrypt(randomOtp, SECRET_KEY).toString();

//   // Step 3: Save encrypted OTP in state and localStorage
//   setOtpSent(encryptedOtp);
//   localStorage.setItem("generatedOtp", encryptedOtp);

//    // ✅ Update Credentials with the generated OTP
//   setCredentials(prev => ({
//     ...prev,
//     StudentOtp: randomOtp
//   }));

//   const payload = {
//     email,
//     otp: randomOtp
//   };

//   try {
//     const res = await axiosInstance.post("/api/send-StudentSignup-otp", payload);
//     if (res.status === 200) {
//       console.log("OTP sent successfully");
//       setResendTimer(60);
//     }
//   } catch (err) {
//     console.error("Failed to send OTP:", err);
//   }
// };

// Check OTP whenever inputs change

const generateAndSendOtp = async (e) => {
  e.preventDefault();
  if (resendTimer > 0) return;

  const email = Credentials?.Email;
  if (!email) {
    setErrors({ ...Errors, Email: "Please enter your email first" });
    setOtpError("Please enter your email first");
    return;
  }

  try {
    const res = await axiosInstance.post("/api/send-StudentLogin-otp", { email });
    if (res.status === 200) {
      setResendTimer(60);
      setOtpError("");
    }
  } catch (err) {
    console.error("Failed to send OTP:", err);
    setOtpError(err?.response?.data?.message || "Failed to send OTP");
  }
};

// useEffect(() => {
//   if (AuthPageName !== "Sign In") return;

//   const enteredOtp = otp.join("");
//   const sentOtp = Credentials?.StudentOtp;

//   if (enteredOtp.length === 4) {
//     if (enteredOtp === sentOtp) {
//       setOtpVerified(true);
//       setOtpError("");
//     } else {
//       setOtpVerified(false);
//       setOtpError("OTP not verified");
//     }
//   } else {
//     setOtpVerified(false);
//     setOtpError("");
//   }
// }, [otp]);

useEffect(() => {
  if (AuthPageName !== "Sign In") return;

  const enteredOtp = otp.join("");
  if (enteredOtp.length !== 4) {
    setOtpVerified(false);
    setOtpError("");
    return;
  }

  const verifyOtp = async () => {
    try {
      const res = await axiosInstance.post("/api/verify-StudentSignin-otp", {
        email: Credentials?.Email,
        otp: enteredOtp,
      });
      if (res.data.success) {
        setOtpVerified(true);
        setOtpError("");
      } else {
        setOtpVerified(false);
        setOtpError(res.data.message || "OTP not verified");
      }
    } catch (err) {
      setOtpVerified(false);
      setOtpError(err?.response?.data?.message || "OTP not verified");
    }
  };

  verifyOtp();
}, [otp]);

  return (
    <div className={`${mar} flex w-full flex-col gap-3 lg:gap-2`}>
      {AuthPageName !== "Sign Up" ? (
        <h4 className="font-normal text-[red]"> {Errors?.Invalid} </h4>
      ) : null}

      <Name
        AuthPageName={AuthPageName}
        Errors={Errors}
        InputBoxStyle={InputBoxStyle}
        Credentials={Credentials}
        setCredentials={setCredentials}
        OnChange={OnChange}
        label="Name"
      />

      <span className="flex flex-col">
        <label className={`${labelStyle}`} htmlFor="EmailAddress">
          Email Address *
        </label>
        <h4 className="font-normal text-[red]">
          {" "}
          {AuthPageName === "Sign Up" ? Errors?.Email : null}{" "}
        </h4>

        <input
          id="EmailAddress"
          className={`${
            Errors?.Email === true
              ? "border-[1px]  border-solid border-[red]"
              : " border-[1px]  border-solid border-[#BCBCBC]"
          } ${InputBoxStyle} max-w-[650px]`}
          type="email"
          placeholder="Email Address"
          required
          value={Credentials?.Email}
          onChange={(e) => OnChange(e, "Email")}
        />
      </span>

      {AuthPageName === "Sign In" && (

        <div className="w-full flex flex-col lg:flex-row gap-[15px] lg:gap-[0px] lg:justify-between lg:items-center my-[10px]">
              <div>
                {otp.map((value, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength={1}
                    value={value}
                    onChange={(e) => handleOTPChange(e.target, index)}
                    className={`w-[40px] h-[54px] rounded-md py-2 mr-[5px] px-[5px] ${Border} text-bold shadow-[4px_5px_6px_#00000029] text-center`}
                  />
                ))}
              </div>

              <div className="flex gap-[5px] items-center">
                    <p className="text-[18px] text-[#FFBBBB]">{resendTimer > 0 ? `Resend OTP (${resendTimer}s)` : ""}</p>
                    <button className={`w-[130px] h-[41px] rounded-[6px] bg-[#625BA8] text-[18px] text-[#FFF] ${
                      resendTimer > 0 ? "cursor-not-allowed" : "cursor-pointer"
                    }`}
                    style={{border:"1px solid #BCBCBC"}}
                    disabled={resendTimer > 0}
                    onClick={generateAndSendOtp}
                    >
                          Obtain OTP
                    </button>
              </div>
        </div>

      )}

      {otpError && (
        <h4 className="font-normal text-[red]">
          {otpError}
        </h4>
      )}


      <span>
        <label className={`${labelStyle}`} htmlFor="Password">
          Password *
        </label>
        <h4 className="font-normal text-[red]"> {Errors?.Password} </h4>

        <input
          id="Password"
          className={`${
            Errors?.Password === true
              ? "border-[1px]  border-solid border-[red]"
              : " border-[1px]  border-solid border-[#BCBCBC]"
          }  ${InputBoxStyle} mt-1 max-w-[650px]`}
          type={view ? `password` : 'text'}
          placeholder={!view ? `password` : "************"}
          required
          value={Credentials?.Password}
          onChange={OnPasswordChange}
        />
        <div className="w-full relative " style={{top: '-38px', position: 'relative'}}> 
          {
            view ?
            <span onClick={()=> setView(prev=> !prev)} className="material-symbols-outlined cursor-pointer absolute top-[5px] md:top-[5px] xl:top-0 right-[13px] text-[16px] text-gray-400" style={{fontSize:'30px'}} >visibility</span> 
            :
            <span onClick={()=> setView(prev=> !prev)} className="material-symbols-outlined cursor-pointer absolute top-[5px] md:top-[5px] xl:top-0 right-[13px] text-[16px] text-gray-400" style={{fontSize:'30px'}}>visibility_off</span>
          }
          </div>
      </span>
      {AuthPageName === "Sign Up" ? (
        <span className="flex flex-col">
          <label className={`${labelStyle}`} htmlFor="ConfirmPassword">
            Confirm Password *
          </label>
          <h4 className="font-normal text-[red]">
            {AuthPageName === "Sign Up" ? Errors?.ConfirmPassword : null}
            {AuthPageName === "Sign Up" && PasswordError && PasswordError}
          </h4>

          <input
            id="ConfirmPassword"
            className={`${
              Errors?.ConfirmPassword === true
                ? "border-[1px]  border-solid border-[red]"
                : " border-[1px]  border-solid border-[#BCBCBC]"
            } ${InputBoxStyle} max-w-[650px]`}
            type={cview ? `password` : 'text'}
            placeholder={!cview ? `Confirm Password` : "************"}
            required
            value={Credentials.ConfirmPassword}
            onChange={(e) => OnChange(e, "ConfirmPassword")}
          />
          <div className="w-full relative " style={{top: '-38px', position: 'relative'}}> 
          {
            cview ?
            <span onClick={()=> setCivew(prev=> !prev)} className="material-symbols-outlined cursor-pointer absolute top-[5px] md:top-[5px] xl:top-0 right-[13px] text-[16px] text-gray-400" style={{fontSize:'30px'}} >visibility</span> 
            :
            <span onClick={()=> setCivew(prev=> !prev)} className="material-symbols-outlined cursor-pointer absolute top-[5px] md:top-[5px] xl:top-0 right-[13px] text-[16px] text-gray-400" style={{fontSize:'30px'}}>visibility_off</span>
          }
          </div>
          

        </span>
      ) : null}
    </div>
  );
};
function Name({
  AuthPageName,
  InputBoxStyle,
  Credentials,
  OnChange,
  Errors,
  label,
}) {
  return AuthPageName === "Sign Up" ? (
    <>
      <div className="absolute">
        <label
          className="relative text-white md:text-black top-[-1.75rem] left-0 text-[15px] font-normal "
          htmlFor="fName"
        >
          {label} *
        </label>
      </div>
      <span className="flex w-full gap-2 xs:gap-3 sm:gap-2 md:gap-2 lg:gap-8 xl:gap-10 2xl:gap-12">
        <span className="flex basis-[50%] flex-col">
          <h4 className="font-normal text-[red]">
            {" "}
            {AuthPageName === "Sign Up" ? Errors?.FirstName : null}{" "}
          </h4>

          <input
            id="fName"
            className={`${
              Errors?.FirstName === true
                ? "border-[1px]  border-solid border-[red]"
                : " border-[1px]  border-solid border-[#BCBCBC]"
            } ${InputBoxStyle}  `}
            type="text"
            placeholder="First Name"
            required
            value={Credentials.FirstName}
            onChange={(e) => OnChange(e, "FirstName")}
          />
        </span>

        <span className="basis-[50%]">
          <h4 className="font-normal text-[red]">
            {" "}
            {AuthPageName === "Sign Up" ? Errors?.LastName : null}{" "}
          </h4>

          <input
            className={`${
              Errors?.LastName === true
                ? "border-[1px]  border-solid border-[red]"
                : " border-[1px]  border-solid border-[#BCBCBC]"
            } ${InputBoxStyle}  basis-[50%] md:text-[16px]`}
            type="text"
            placeholder="Last Name"
            required
            value={Credentials.LastName}
            onChange={(e) => OnChange(e, "LastName")}
          />
        </span>
      </span>
    </>
  ) : null;
}
export default UserInput;
